module.exports = __webpack_public_path__ + "static/media/final.fb430a7b.png";